export const requestTypes = {
  RESPONSES: 'responses',
  TAGS: 'tags',
  CATEGORIES: 'categories',
  QUESTIONS: 'questions',
  TAGS_RESULTS_PER_PERSON: 'tagsResultsPerPerson',
  CATEGORIES_RESULTS_PER_PERSON: 'categoriesResultsPerPerson',
  GROUP_RESULTS_FOR_SURVEY: 'groupResultsForSurvey',
  QUESTION_RESULTS_FOR_SURVEY: 'questionResultsForSurvey',
  SURVEY_DETAILS: 'surveyDetails',
  FILTERED_SURVEY_DETAILS: 'surveyApiSurveyDetails',
  SURVEYS: 'surveys',
  INSIGHTS_TEAM: 'insightsTeam',
  INSIGHTS_LEADERSHIP: 'insightsLeadership',
  ACTIONS: 'actions',
  TREND_TAGS: 'trendTags',
  TREND_CATEGORIES: 'trendCategories',
  TREND_QUESTIONS: 'trendQuestions',
  NOTES: 'notes'
}
